module.exports = __webpack_public_path__ + "static/img/jolly88-logo.3f21a0ac.png";